export function toIdentifier(raw: string, camel = true): string {
    // 1. Normalise les caractères accentués : "é" → "é" (e + diacritique)
    let id = raw.normalize('NFKD')
        // 2. Supprime les diacritiques (U+0300‑036F)  
        .replace(/[\u0300-\u036f]/g, '')
        // 3. Remplace tout ce qui n’est pas a‑z, A‑Z, 0‑9, _ ou $ par «_»
        .replace(/[^a-zA-Z0-9_$]/g, '_');

    // 4. Si ça commence par un chiffre, on préfixe d’un «_»
    if (/^[0-9]/.test(id)) {
        id = '_' + id;
    }

    // 5. (facultatif) camelCase pour ressembler à un identifiant JS classique
    if (camel) {
        id = id.replace(/_+([a-zA-Z0-9])/g, (_, c) => c.toUpperCase());
    }

    return id;
}